import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import { couponSchema } from '../../../util/validationSchema'
import { addCoupons, editCoupons } from '../../../redux/slices/couponsSlice'
import { SpinnerContext } from '../../../context/spinnerContext'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { convertTimestampToCalenderDate, getTimeStamp, isDateAfter, isDateBefore } from '../../../helper/function'
import CommonDateTimePicker from '../../../component/commonDateTimePicker'
// import DollarIcon from '../../../assets/img/svg/dollar.svg'
// import DiscountIcon from '../../../assets/img/svg/discount.svg'

const AddEditCouponsModal = ({ couponID, toggle, setIsRefresh, editData }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const defaultValues = editData
    ? {
        name: editData?.name,
        amount_limit: editData?.amount_limit,
        code: editData?.code,
        application_from_date: editData?.application_from_date ? convertTimestampToCalenderDate(editData?.application_from_date) : '',
        application_till_date: editData?.application_till_date ? convertTimestampToCalenderDate(editData?.application_till_date) : '',
        discount: editData?.discount,
        max_uses: editData?.max_uses || 0,
        coupon_type: editData?.coupon_type || 'percentage'
      }
    : { coupon_type: 'percentage' }

  const {
    control,
    trigger,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(couponSchema),
    defaultValues
  })

  const onSubmit = (data) => {
    changeLoader(true)
    const payload = {
      ...data,
      application_from_date: data?.application_from_date && getTimeStamp(data?.application_from_date),
      application_till_date: data?.application_till_date && getTimeStamp(data?.application_till_date)
    }
    const editPayload = {
      data: payload,
      id: couponID
    }
    const dispatchAction = couponID ? editCoupons(couponID ? editPayload : payload) : addCoupons(payload)

    dispatch(dispatchAction)
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggle()
          changeLoader(false)
          setIsRefresh(true)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Coupon Title</label>
                      <span className="text-danger"> *</span>
                      <Controller
                        name="name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Coupon Title"
                              onChange={(val) => {
                                onChange(val)
                                trigger('name')
                              }}
                            />
                            <small>{errors.name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <label className="fw-500" style={{ fontSize: '16px', color: '#252525' }}>
                      Amount Limit
                    </label>
                    <span className="text-danger"> *</span>
                    <div className="input_icon_box icon_filed_div">
                      <div className="form-group mb-0 w-100 input_with_icon position-relative">
                        <Controller
                          name="amount_limit"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="form-control-icon-wrap">
                              <input
                                className="form-control form-control-with-icon"
                                value={value}
                                type="number"
                                placeholder="Enter Amount Limit"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('amount_limit')
                                }}
                              />
                              <span className="info_box_div" style={{ top: '25px', right: '10px' }}>
                                <span>$</span>
                              </span>
                              <small>{errors.amount_limit?.message}</small>
                            </div>
                          )}
                          defaultValue=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Code</label>
                      <span className="text-danger"> *</span>
                      <Controller
                        name="code"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Code"
                              onChange={(val) => {
                                onChange(val)
                                trigger('code')
                              }}
                              disabled={couponID}
                            />
                            <small>{errors.code?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 form-group">
                    <label>Valid Period</label>
                    <div className="row">
                      <div className="col-md-6">
                        <label>From</label>
                        <span className="text-danger"> *</span>
                        <div>
                          <div className="date_picker_main_div">
                            <CommonDateTimePicker
                              name="application_from_date"
                              control={control}
                              className="form-control bg-transparent dark_border"
                              placeholder="DD/MM/YYYY"
                              onDateChange={() => {
                                trigger('application_from_date')
                              }}
                              shouldDisableDate={(date) => isDateAfter(date, watch('application_till_date'))}
                              type="DatePicker"
                              format="DD/MM/YYYY"
                              disablePast={false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="filed_main_div_data">
                          <label>To</label>
                          <span className="text-danger"> *</span>
                          <div className="date_picker_main_div">
                            <CommonDateTimePicker
                              name="application_till_date"
                              control={control}
                              className="form-control bg-transparent dark_border"
                              placeholder="DD/MM/YYYY"
                              onDateChange={() => {
                                trigger('application_till_date')
                              }}
                              type="DatePicker"
                              shouldDisableDate={(date) => isDateBefore(date, watch('application_from_date'))}
                              format="DD/MM/YYYY"
                              disablePast={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <label className="fw-500" style={{ fontSize: '16px', color: '#252525' }}>
                      Discount
                    </label>
                    <span className="text-danger"> *</span>
                    <div className="input_icon_box icon_filed_div">
                      <div className="form-group mb-0 w-100 input_with_icon position-relative">
                        <Controller
                          name="discount"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="form-control-icon-wrap">
                              <input
                                className="form-control form-control-with-icon"
                                value={value}
                                type="number"
                                placeholder="Enter Discount"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('discount')
                                }}
                              />
                              {watch('coupon_type') === 'percentage' ? (
                                <span className="info_box_div" style={{ top: '25px' }}>
                                  <span>%</span>
                                </span>
                              ) : (
                                <span className="info_box_div" style={{ top: '25px', right: '10px' }}>
                                  <span>$</span>
                                </span>
                              )}
                              <small>{errors.discount?.message}</small>
                            </div>
                          )}
                          defaultValue=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>Max Used</label>
                      <span className="text-danger"> *</span>
                      <Controller
                        name="max_uses"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="number"
                              placeholder="Enter Max Users"
                              onChange={(val) => {
                                onChange(val)
                                trigger('max_uses')
                              }}
                            />
                            <small>{errors.max_uses?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12 d-flex" style={{ justifyContent: 'space-between' }}>
                    <div className="form-group input_text border-remove">
                      <Controller
                        key={`percentage-control`}
                        name={`coupon_type`}
                        control={control}
                        value="percentage"
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={`Percentage`}
                            {...field}
                            checked={field.value == 'percentage'}
                            onChange={() => {
                              trigger('discount')
                              if (field.value == 'flat') {
                                field.onChange('percentage')
                              } else {
                                field.onChange('flat')
                              }
                            }}
                          />
                        )}
                      />
                    </div>
                    <div className="form-group input_text border-remove">
                      <Controller
                        key={`fixed-price-control`}
                        name={`coupon_type`}
                        control={control}
                        value="flat"
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            label={`Fixed Price`}
                            {...field}
                            checked={field.value == 'flat'}
                            onChange={() => {
                              if (field.value == 'flat') {
                                field.onChange('percentage')
                              } else {
                                field.onChange('flat')
                              }
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  {couponID ? `Update` : `Create`}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default AddEditCouponsModal
